const OpenAPI = () => import('@/views/open-api/open-api-view.vue');


export default [
    {
        path: '/OpenAPI/Keys/',
        name: 'OpenAPIKeys',
        component: OpenAPI,
        meta: {
            isUiShown: true,
            type: 'client',
            pageClass: 'open-api-keys-index-page',
            pageTitle: 'Open API Keys'
        }
    },
    {
        path: '/Clients/:clientId/OpenAPI/Keys',
        name: 'ClientOpenAPIKeys',
        component: OpenAPI,
        meta: {
            isUiShown: true,
            type: 'client',
            pageClass: 'open-api-keys-index-page',
            pageTitle: 'Open API Keys'
        }
    },
    {
        path: '/Agencies/:agencyId/OpenAPI/Keys',
        name: 'AgencyOpenAPIKeys',
        component: OpenAPI,
        meta: {
            isUiShown: true,
            type: 'agency',
            pageClass: 'open-api-keys-index-page',
            pageTitle: 'Open API Keys'
        }
    },
    {
        path: '/MasterAgencies/:masterAgencyId/OpenAPI/Keys',
        name: 'MasterAgencyOpenAPIKeys',
        component: OpenAPI,
        meta: {
            isUiShown: true,
            type: 'master-agency',
            pageClass: 'open-api-keys-index-page',
            pageTitle: 'Open API Keys'
        }
    }
]